import { useState, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

export default function usePageLoader() {
  const [isLoading, setIsLoading] = useState(false);
  const location = useLocation();

  useEffect(() => {
    // Mostrar loader al cambiar de ruta
    setIsLoading(true);
    
    // Ocultar loader después de un tiempo mínimo
    const timer = setTimeout(() => {
      setIsLoading(false);
    }, 300); // Reducido a 300ms para ser más rápido

    return () => clearTimeout(timer);
  }, [location.pathname]);

  return { isLoading, setIsLoading };
}
